import React from 'react';
import { useSelector } from 'react-redux';
import { GlobalStore } from '../../store';
import User from '../../models/User';

interface TaOnDuty {
  realname: string;
  username: string;
}

interface Props {
  queueName: string;
  tas: TaOnDuty[];
}

export default ({ queueName, tas }: Props): JSX.Element | null => {
  const user = useSelector<GlobalStore, User | null>(store => store.user);

  const isTA = user !== null && (user.isTeacherIn(queueName) || user.isAssistantIn(queueName));

  if (!isTA) return null;

  return (
    <details className="col-12 mt-3 p-0">
      <summary className="clickable" style={{ listStyle: 'none', display: 'block', padding: '8px 12px', fontWeight: 600, borderRadius: '4px', background: '#f0f0f0', border: '1px solid #ccc', marginBottom: '4px' }}>
        On duty ({tas.length})
      </summary>
      <div className="mt-1">
        {tas.length === 0
          ? <p className="text-muted" style={{ fontSize: '0.9em' }}>No TAs on duty.</p>
          : <ul className="list-unstyled mb-0" style={{ fontSize: '0.9em' }}>
              {tas.map(ta => (
                <li key={ta.username} title={ta.username}>{ta.realname}</li>
              ))}
            </ul>
        }
      </div>
    </details>
  );
};
